export default __webpack_public_path__ + "static/media/sushi-chien.cbb952ac.jpg";